import React from 'react';
import styles from './DriverConsent.module.scss';

const DetailSection = (props) => {
    const { setNameData, fullName, licenceNumber, licenceVersion, dob, companyName } = props;

    const onTextChange = (e) => {
      setNameData({ name: e.target.name, value: e.target.value });
    }

    return (
        <div className={`section ${styles.sectionGrey}`} style={{ backgroundColor: '#f0f0f0', padding: '20px 10px' }}>
          <div className="row">
            <div className="col-md-2">
              <h3>Licence holder&apos;s details</h3>
              <p className="small">
                You must fill in all fields <br/> in this section marked <br/> with an asterisk (*).
              </p>
            </div>
            <div className="col-md-10">
                <div className={styles.darkGrey}>
                    <div className="row mb-3">
                        <div className="col-md-10">
                        <div className="form-group d-flex align-items-center">
                            <label htmlFor="fullName" className="mr-2">I,</label>
                            <input
                            type="text"
                            id="fullName"
                            name="fullName"
                            className="form-control"
                            value={fullName}
                            onChange={onTextChange}
                            maxLength={40}
                            required
                            />
                        </div>
                        </div>
                        <div className="col-md-2 d-flex align-items-center">
                        <span>*(licence holder's name)</span>
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className="col-md-10">
                        <div className="form-group d-flex align-items-center">
                            <label htmlFor="companyName" className="mr-2">authorize</label>
                            <input
                            type="text"
                            id="companyName"
                            name="companyName"
                            className="form-control"
                            value={companyName}
                            onChange={onTextChange}
                            maxLength={50}
                            required
                            />
                        </div>
                        </div>
                        <div className="col-md-2 d-flex align-items-center">
                        <span>*(company name)</span>
                        </div>
                    </div>
                    <div>
                        to access my driver licence status using the NZ Transport Agency Waka Kotahi Driver Check service.
                    </div>
                </div>
              <div className="row mt-4">
                <div className="col-md-6 mb-3">
                  <div className="form-group">
                    <label htmlFor="licenceNumber">
                      Driver licence number*
                    </label>
                    <input
                      type="text"
                      id="licenceNumber"
                      name="licenceNumber"
                      className="form-control"
                      value={licenceNumber}
                      onChange={onTextChange}
                      maxLength={15}
                      required
                    />
                  </div>
                </div>
                <div className="col-md-6 mb-3">
                  <div className="form-group">
                    <label htmlFor="licenceVersion">
                      Driver licence version number*
                    </label>
                    <input
                      type="text"
                      id="licenceVersion"
                      name="licenceVersion"
                      className="form-control"
                      value={licenceVersion}
                      onChange={onTextChange}
                      maxLength={4}
                      required
                    />
                  </div>
                </div>
                <div className="col-md-6 mb-3">
                  <div className="form-group">
                    <label htmlFor="dob">
                      Date of birth*
                    </label>
                    <input
                      type="date"
                      id="dob"
                      name="dob"
                      className="form-control"
                      value={dob}
                      onChange={onTextChange}
                      placeholder="dd/mm/yyyy"
                      maxLength={10}
                      required
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
      
}

export default DetailSection